import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RevealDirective } from '../../core/directives/reveal.directive';

@Component({
  selector: 'hx-referral-promo-band',
  standalone: true,
  imports: [RouterLink, RevealDirective],
  template: `
    <div class="wrap">
      <a routerLink="/promotions" class="hero-promo-band reveal" appReveal>
        <div class="hero-promo-copy">
          <span class="hero-promo-tag">Referral Program</span>
          <h2>Refer a business, get rewarded.</h2>
          <p>Send us a client and earn a reward the moment their project kicks off — no waiting for delivery.</p>
        </div>
        <span class="btn btn-primary hero-promo-btn">View promotions &amp; referrals →</span>
      </a>
    </div>
  `,
})
export class ReferralPromoBandComponent {}
